/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import SegmentEventsUtil from '@utils/SegmentEventsUtils';
import { useSnackbar } from '@stores/snackbar';
import useDarkModeStatus from '@stores/useDarkModeStatus';
import { getUserPreferredThemeSetter } from '@stores/selectors/darkModeStatusSelectors';

const Iframe = styled.iframe`
  height: 100vh;
  grid-column: 11/25;
`;

const SimpleCanvas = ({
  setRoomUID,
  recordingURL,
  liveClassData,
  permissions,
  className,
  onReady,
  onMessage,
  setShowAddToCanvas,
  additionalEvtData
}) => {
  // console.log('RECORDING URL', recordingURL);
  const setUserPreferredTheme = useDarkModeStatus(getUserPreferredThemeSetter);
  const [isLoaded, setIsLoaded] = useState(false);
  const { open: showSnackbar } = useSnackbar();

  const onMessageReceived = (e) => {
    if (e.data.liveClassReady) {
      document
        .getElementById('educatorCanvas')
        ?.contentWindow?.postMessage(liveClassData, '*');
      onReady();
    }

    if (e.data.eventType === 'SESSION_DISCONNECTED') {
      setShowAddToCanvas(false);
    }
    if (e.data.eventType === 'SESSION_CONNECTED') {
      setShowAddToCanvas(true);
    }

    if (e.data.eventType === 'START_RECORDING_SUCCESS') setRoomUID(null);
    else if (e.data.eventType === 'END_RECORDING_SUCCESS')
      setRoomUID(e.data.roomUid);
    else if (e.data.eventType === 'START_RECORDING_ERROR')
      showSnackbar({
        message: e.data.errorDescription || 'Active room already exists',
        type: 'error'
      });

    if (e.data.segmentEvents) {
      SegmentEventsUtil.sendEvent(e.data.eventData, additionalEvtData);
    }

    if (e.data.setDarkModeOn) {
      setUserPreferredTheme(e.data.setDarkModeOn.shouldSet);
    }
    onMessage(e);
  };

  useEffect(() => {
    if (!isLoaded) setIsLoaded(true);
    window.addEventListener('message', onMessageReceived);
    return () => {
      window.removeEventListener('message', onMessageReceived);
    };
  }, []);

  if (!isLoaded) return null;
  return (
    <Iframe
      src={recordingURL}
      id="educatorCanvas"
      webkitallowfullscreen="true"
      allowFullScreen
      width="100%"
      height="100%"
      allow={permissions}
      frameBorder="no"
      title="Canvas"
      className={className}
    />
  );
};

export default SimpleCanvas;

SimpleCanvas.propTypes = {
  setRoomUID: PropTypes.func,
  recordingURL: PropTypes.string.isRequired,
  liveClassData: PropTypes.objectOf(PropTypes.any),
  permissions: PropTypes.string,
  className: PropTypes.string,
  onReady: PropTypes.func,
  onMessage: PropTypes.func,
  setShowAddToCanvas: PropTypes.func,
  additionalEvtData: PropTypes.objectOf(PropTypes.any)
};

SimpleCanvas.defaultProps = {
  liveClassData: {},
  setRoomUID: () => {},
  permissions: 'camera; microphone;',
  className: '',
  onReady: () => {},
  onMessage: () => {},
  setShowAddToCanvas: () => {},
  additionalEvtData: {}
};
